import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import {
  chapterMarkerStyle,
  isActiveStyle,
} from "./toc_chapter_marker.module.scss";

function TOCChapterMarker({ isActive }) {
  const wrapperClassNames = classNames(chapterMarkerStyle, {
    [isActiveStyle]: isActive,
  });

  return <div className={wrapperClassNames} />;
}

TOCChapterMarker.propTypes = {
  isActive: PropTypes.bool,
};

TOCChapterMarker.defaultProps = {
  isActive: false,
};

export default TOCChapterMarker;
